module.exports = __webpack_public_path__ + "static/pdn-200705.6c5d4852.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/pdn-200705.jpg
// module id = 664
// module chunks = 174759553322802